'use client';

import cn from 'classnames';
import styles from './staranimation.module.scss';
import { IconStar } from '@/assets/icons/IconStar';

export type StarAnimationProps = {
    animate: boolean;
};

const TOTAL_STARS = 7;
const getPositions = () => {
    return Array.from({ length: TOTAL_STARS }).map((_, i) => {
        const angle = (Math.PI * 2 * i) / (TOTAL_STARS - 1) + (Math.random() - 0.5) * 0.3;
        const distance = 100 + Math.random() * 30;

        return {
            endx: `${Math.ceil(Math.cos(angle) * distance)}px`,
            endy: `${Math.ceil(Math.sin(angle) * distance)}px`,
        };
    });
};

export const StarAnimation = ({ animate = false }: StarAnimationProps) => {
    const positions = getPositions();

    return (
        <>
            {Array.from({ length: TOTAL_STARS }).map((_, i) => {
                const starStyle: React.CSSProperties & Record<string, string> = {
                    '--endx': positions[i]?.endx ?? '0px',
                    '--endy': positions[i]?.endy ?? '0px',
                };

                const starClass = cn(styles.star, {
                    [styles.bigStar]: i === 0,
                    [styles.animate]: animate,
                });

                return (
                    <div key={i} className={starClass} style={starStyle}>
                        <IconStar />
                    </div>
                );
            })}
        </>
    );
};
